@if(elevationData()) {
  <div class="chart-container">
      <!--<span class="upper-legend">{{ gpxStatsData()?.maxElevation }} m</span>-->
      <canvas #elevationCanvas></canvas>
      <!--<div class="legend">
          <span>{{ gpxStatsData()?.minElevation }} m</span>
          <span>{{ gpxStatsData()?.maxDistance }} km</span>
      </div>-->
  </div>
}